// helpers.ts ----------------------------------------------------------
import { SyncableCfg } from '@/lib/sync-manager/types'

/**
 * Local-only fields of rows on collections that push (docs/sync/UNSENT.md). A
 * type, not an interface: rows typed with it still fit RowBase's index signature.
 */
export type UnsentMarker = {
  // Set while the row has changes not yet on the server
  _dirty?: 1
  // Renewed on every local write and every server copy written over it
  _rev?: string
}

/** A row without its local-only fields, for the API and for forms. */
export function withoutUnsentMarker<R extends object>(
  row: R
): Omit<R, keyof UnsentMarker> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { _dirty, _rev, ...rest } = row as R & UnsentMarker
  return rest
}

/** Rows must have at least an id */
export interface RowBase extends UnsentMarker {
  ///id: string
  [k: string]: unknown
}

export function createSyncable<R extends RowBase, CP = Date>(
  cfg: SyncableCfg<R, CP>
): SyncableCfg<R, CP> {
  return cfg
}

// Legacy alias for backward compatibility
export const collectionCfg = createSyncable
